// extracted by mini-css-extract-plugin
var _1 = "NewPostHistoryView-module__controlBar--uc5vj";
var _2 = "NewPostHistoryView-module__emptyStateContainer--t4c7m";
export { _1 as "controlBar", _2 as "emptyStateContainer" }
